import React, { useState, useEffect } from 'react';
import '../styles/PhoneticDisplay.css';

const PhoneticDisplay = ({ text, isVisible = true }) => {
  const [phoneticText, setPhoneticText] = useState('');
  const [showPhonetic, setShowPhonetic] = useState(false);

  // Simple phonetic conversion for common English words
  const phoneticDictionary = {
    'tree': '/triː/',
    'flower': '/ˈflaʊər/',
    'moon': '/muːn/',
    'ocean': '/ˈoʊʃən/',
    'snow': '/snoʊ/',
    'stars': '/stɑːrz/',
    'rainbow': '/ˈreɪnboʊ/',
    'forest': '/ˈfɔːrɪst/',
    'waterfall': '/ˈwɔːtərfɔːl/',
    'clouds': '/klaʊdz/',
    'bird': '/bɜːrd/',
    'butterfly': '/ˈbʌtərflaɪ/',
    'cat': '/kæt/',
    'dog': '/dɔːɡ/',
    'fish': '/fɪʃ/',
    'rabbit': '/ˈræbɪt/',
    'bee': '/biː/',
    'squirrel': '/ˈskwɜːrəl/',
    'frog': '/frɔːɡ/',
    'ant': '/ænt/',
    'book': '/bʊk/',
    'car': '/kɑːr/',
    'house': '/haʊs/',
    'ball': '/bɔːl/',
    'toy': '/tɔɪ/',
    'chair': '/tʃer/',
    'lamp': '/læmp/',
    'phone': '/foʊn/',
    'clock': '/klɑːk/',
    'happiness': '/ˈhæpɪnəs/',
    'love': '/lʌv/',
    'sadness': '/ˈsædnəs/',
    'excitement': '/ɪkˈsaɪtmənt/',
    'peace': '/piːs/',
    'anger': '/ˈæŋɡər/',
    'fear': '/fɪr/',
    'hope': '/hoʊp/',
    'gratitude': '/ˈɡrætɪtuːd/'
  };

  // Function to get phonetic representation
  const getPhoneticText = (text) => {
    if (!text) return '';
    
    // Split text into words and get phonetic for each
    const words = text.toLowerCase().replace(/[^\w\s]/g, '').split(/\s+/);
    const phoneticWords = words.map(word => {
      return phoneticDictionary[word] || `/${word}/`;
    });
    
    return phoneticWords.join(' ');
  };

  useEffect(() => {
    if (text) {
      setPhoneticText(getPhoneticText(text));
    }
  }, [text]);

  const togglePhonetic = () => {
    setShowPhonetic(!showPhonetic);
  };

  if (!isVisible || !text) {
    return null;
  }

  return (
    <div className="phonetic-display">
      <button
        onClick={togglePhonetic}
        className={`phonetic-toggle ${showPhonetic ? 'active' : ''}`}
        title={showPhonetic ? 'Hide Phonetic' : 'Show Phonetic'}
      >
        <span className="phonetic-icon">🔊</span>
        <span className="phonetic-label">
          {showPhonetic ? 'Hide IPA' : 'Show IPA'}
        </span>
      </button>
      
      {showPhonetic && phoneticText && (
        <div className="phonetic-text">
          <div className="phonetic-label-small">IPA Pronunciation:</div>
          <div className="phonetic-content">{phoneticText}</div>
        </div>
      )}
    </div>
  );
};

export default PhoneticDisplay;
